module.exports = __webpack_public_path__ + "img/mgh-kanazawa.45f4aea5.jpg";